(function ($) {
  "use strict";
  $(document).ready(function(){
    $('.height-product').matchHeight();


    $(".update-button span.add-update a").append(' <i class="fa fa-pencil"></i>');
    $(".update-button span.add-delete a").append(' <i class="fa fa-trash"></i>');     

    /*---------------------
	 jQuery MeanMenu
	--------------------- */
    jQuery('nav#dropdown').meanmenu();

    /*---------------------
 	scrollUp
	--------------------- */	
    $.scrollUp({
      scrollText: '<i class="fa fa-angle-up"></i>',
      easingType: 'linear',
      scrollSpeed: 900,
      animation: 'fade'
    });

    /*---------------------
	 1. owl-carousel
	--------------------- */
    $(".product-carusul").owlCarousel({
      autoPlay: false, //Set AutoPlay to 3 seconds
      navigation : true,
      navigationText : ["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],
      pagination :false,
      items : 5,
      itemsDesktop : [1199,5],
      itemsDesktopSmall : [979,2],
      itemsMobile : [767,1]
    });

    /*---------------------
	 2. owl-carousel
	--------------------- */
    $(".new-product-carosul").owlCarousel({
      autoPlay: false, //Set AutoPlay to 3 seconds
      navigation : true,
      navigationText : ["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],
      pagination :false,
      items : 4,
      itemsDesktop : [1199,4],
      itemsDesktopSmall : [979,2],
      itemsMobile : [767,1]
    });

    /*---------------------
	 3. owl-carousel
	--------------------- */
    $(".add-banner-carsuol, .recent-post").owlCarousel({
      autoPlay: false, //Set AutoPlay to 3 seconds
      navigation : false,
      navigationText : ["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],
      pagination :true,
      items : 1,
      itemsDesktop : [1199,1],
      itemsDesktopSmall : [979,1],
      itemsMobile : [767,1]
    });

    /*---------------------
	 special-product
	--------------------- */    
    $(".special-product-carosul").owlCarousel({
      autoPlay: false, //Set AutoPlay to 3 seconds
      navigation : true,
      navigationText : ["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],
      pagination :false,
      items : 1,
      itemsDesktop : [1199,1],
      itemsDesktopSmall : [979,1],
      itemsMobile : [767,1]
    });    


    /*---------------------
	 4. owl-carousel
	--------------------- */
    $(".logo-brand-carosul").owlCarousel({
      autoPlay: false, //Set AutoPlay to 3 seconds
      navigation : true,
      navigationText : ["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],
      pagination :false,
      items : 6,
      itemsDesktop : [1199,6],
      itemsDesktopSmall : [979,4],
      itemsMobile : [767,1]
    });

    /*---------------------
	 5. owl-carousel
	--------------------- */
    $(".product-carusul-pagination").owlCarousel({
      autoPlay: false, //Set AutoPlay to 3 seconds
      navigation : false,
      navigationText : ["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],
      pagination :true,
      items : 5,
      itemsDesktop : [1199,5],
      itemsDesktopSmall : [979,2],
      itemsMobile : [767,1]
    });

    /*---------------------
	 6. owl-carousel
	--------------------- */
    $(".blog-carosul").owlCarousel({
      autoPlay: false, //Set AutoPlay to 3 seconds
      navigation : false,
      navigationText : ["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],
      pagination :true,
      items : 3,
      itemsDesktop : [1199,3],
      itemsDesktopSmall : [979,2],
      itemsMobile : [767,1]
    });



    /*---------------------
	 6. single product 
	--------------------- */
    $(".thumb-slider").owlCarousel({
      autoPlay: false, //Set AutoPlay to 3 seconds
      navigation : true,
      navigationText : ["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],
      pagination :false,
      items : 3,
      itemsDesktop : [1199,3],
      itemsDesktopSmall : [979,2],
      itemsMobile : [767,2]
    });    

    /*----- about pager testimonial -----*/	
    $(".what-client-say").owlCarousel({
      items : 1,
      itemsDesktop : [1199,1],
      itemsDesktopSmall : [991,1],
      itemsTablet: [767,1],
      itemsMobile : [480,1],
      autoPlay: false,
      navigation: false,
      pagination: true,
      singleItem : true,
      transitionStyle : "backSlide"
    });		
    /*---------------------
	 7. owl-carousel
	--------------------- */
    $(".post-slider").owlCarousel({

      autoPlay: false, //Set AutoPlay to 3 seconds
      navigation : true,
      navigationText : ["<i class='fa fa-caret-left'></i>","<i class='fa fa-caret-right'></i>"],
      pagination :true,
      items : 1,
      itemsDesktop : [1199,1],
      itemsDesktopSmall : [979,1],
      itemsMobile : [767,1],

    });

    /*---------------------
	 Category menu
	--------------------- */
    $('#cate-toggle li.has-sub>a').on('click', function(){
      $(this).removeAttr('href');
      var element = $(this).parent('li');
      if (element.hasClass('open')) {
        element.removeClass('open');
        element.find('li').removeClass('open');
        element.find('ul').slideUp();
      }
      else {
        element.addClass('open');
        element.children('ul').slideDown();
        element.siblings('li').children('ul').slideUp();
        element.siblings('li').removeClass('open');
        element.siblings('li').find('li').removeClass('open');
        element.siblings('li').find('ul').slideUp();
      }
    });
    $('#cate-toggle>ul>li.has-sub>a').append('<span class="holder"></span>');




    /*---------------------
	Nivo slider
	--------------------- */			
    $('#ensign-nivoslider').nivoSlider({
      effect: 'slideInRight',
      slices: 15,
      boxCols: 8,
      boxRows: 4,
      animSpeed: 500,
      pauseTime: 5000,
      startSlide: 0,
      directionNav: true,
      controlNavThumbs: false,
      pauseOnHover: false,
      manualAdvance: false
    });	
    $('#ensign-nivoslider-2').nivoSlider({
      effect: 'fade',
      slices: 15,
      boxCols: 8,
      boxRows: 4,
      animSpeed: 500,
      pauseTime: 5000,
      startSlide: 0,
      directionNav: true,
      controlNavThumbs: true,
      pauseOnHover: true,
      manualAdvance: false
    });
    /*---------------------
	fancybox
	--------------------- */	
    $('.fancybox').fancybox();    


    /*---------------------
	 Input Number Incrementer
	--------------------- */
    $(".numbers-row").append('<div class="inc button">+</div><div class="dec button">-</div>');
    $(".button").on("click", function() {
      var $button = $(this);
      var oldValue = $button.parent().find("input").val();
      if ($button.text() == "+") {
        var newVal = parseFloat(oldValue) + 1;
      } else {
        // Don't allow decrementing below zero
        if (oldValue > 0) {
          var newVal = parseFloat(oldValue) - 1;
        } else {
          newVal = 0;
        }
      }
      $button.parent().find("input").val(newVal);

    });

    /*----------------------------
         Elevate Zoom active
    ------------------------------ */
    $(".zoom1").elevateZoom({
      gallery:'ProductThumbs',
      cursor: 'pointer',
      imageCrossfade: true
    }); 
    /*----------------------------
         Elevate Zoom active
    ------------------------------ */
    $(".zoom1").elevateZoom({
      gallery:'ProductThumbs',
      cursor: 'pointer',
      galleryActiveClass: 'active',
      imageCrossfade: true
    }); 

    $(".zoom1").bind("click", function(e) {
      var ez = $('.zoom1').data('elevateZoom');
      $.fancybox(ez.getGalleryList());
      return false; });    


  });
})(jQuery);    